/* eslint-disable consistent-return */
import React from 'react';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from './styles';

function Home() {
  return (
    <Container>
      <Menu />
      <Footer />
      <section>
        <h1 style={{ fontSize: '46px', color: '#babaca' }}>HOME</h1>
      </section>
    </Container>
  );
}
export default Home;
